import { render, staticRenderFns } from "./AddTravelTime.vue?vue&type=template&id=45a322dc&scoped=true&"
import script from "./AddTravelTime.vue?vue&type=script&lang=js&"
export * from "./AddTravelTime.vue?vue&type=script&lang=js&"
import style0 from "./AddTravelTime.vue?vue&type=style&index=0&id=45a322dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a322dc",
  null
  
)

export default component.exports